import Navbar from "components/molecules/navbar";
import About from "components/organism/about";
import Experience from "components/organism/experience";
import Services from "components/organism/services";

export const Home = () => {
  return (
    <>
      <Navbar />
      <About />
      <Services />
      <Experience />
    </>
  );
};
